/* eslint-disable max-len */
import React from 'react';
function NoBreak() {
    return (React.createElement("g", null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "" })));
}
export default NoBreak;
